import { configureStore } from '@reduxjs/toolkit';
import authSlice from './slices/auth/slice';
import userSlice from './slices/user/slice';
import influencerRequestSlice from './slices/influencerRequest/slice';
import paymentSlice from './slices/payment/slice';
import withdrawalSlice from './slices/withdrawal/slice';
import agencySlice from './slices/agency/slice';
import influencerFactSlice from './slices/influencerFact/slice';
import influencerExamplesSlice from './slices/influencerExamples/slice';
import collectionsSlice from './slices/collections/slice';
import assetFolderSlice from './slices/assetFolder/slice';
import chatterSlice from './slices/chatter/slice';
import organizationAnalyticsSlice from './slices/organizationAnalytics/slice';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    userInfo: userSlice,
    influencerRequestInfo: influencerRequestSlice,
    paymentInfo: paymentSlice,
    withdrawalInfo: withdrawalSlice,
    agencyInfo: agencySlice,
    influencerFactInfo: influencerFactSlice,
    influencerExamplesInfo: influencerExamplesSlice,
    collectionInfo: collectionsSlice,
    assetFolderInfo: assetFolderSlice,
    chatterInfo: chatterSlice,
    organizationAnalyticsInfo: organizationAnalyticsSlice,
  },
  devTools: false,
});
